import { ISAUSTRALIANLOCATION } from '@/constants';
import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { isResearchOnlyLocation } from '@/utils/replaceLocationBasedTerms';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

export const useMemberInformationConsent = () => {
  const {
    errorsPatientDetails,
    scanDate,
    clinicalConsent,
    termsConsent,
    locationId,
    selectedSku,
    cancellationPolicyConsent,
    setMemberInfo,
    removeError,
  } = usePrenuvoStore(
    useShallow((state) => ({
      errorsPatientDetails: state.user.errors,
      scanDate: state.scan.date,
      selectedSku: state.scan.sku,
      clinicalConsent: state.user.clinicalConsent,
      termsConsent: state.user.termsConsent,
      locationId: state.scan.locationId,
      cancellationPolicyConsent: state.user.cancellationPolicyConsent,
      setMemberInfo: state.user.methods.setMemberInfo,
      removeError: state.user.methods.removeError,
    })),
  );

  const updateConsent = (inputName: string, currentValue: boolean) => {
    removeError(inputName);
    setMemberInfo({ [inputName]: !currentValue });
  };

  const displayPreviousDiagnosisWarning = !(
    isResearchOnlyLocation(locationId) || ISAUSTRALIANLOCATION(locationId)
  );

  // TODO: Cancellation policy checkbox is hidden as it is been decoupled from the interntional expantion launch for a later phase.
  const needsCancellationPolicyConsent = ISAUSTRALIANLOCATION(locationId) && false; // && false added to hide cancellation policy checkbox for now
  useEffect(() => {
    if (!needsCancellationPolicyConsent) {
      removeError('cancellationPolicyConsent');
      setMemberInfo({ cancellationPolicyConsent: true });
    }
  }, [needsCancellationPolicyConsent, removeError, setMemberInfo]);

  const handleConsentChange = (inputName: string, value: boolean) => {
    updateConsent(inputName, value);
  };

  const termsAndConditionsLink = ISAUSTRALIANLOCATION(locationId)
    ? 'http://prenuvo.com/au/terms-and-privacy?section=terms-of-service'
    : 'https://www.prenuvo.com/terms';

  return {
    errorsPatientDetails,
    scanDate,
    clinicalConsent,
    termsConsent,
    locationId,
    selectedSku,
    termsAndConditionsLink,
    displayPreviousDiagnosisWarning,
    needsCancellationPolicyConsent,
    cancellationPolicyConsent,
    setMemberInfo,
    removeError,
    updateConsent,
    handleConsentChange,
  };
};
